import React, { Suspense } from 'react'
import { Outlet } from 'react-router'
import { Button, Spinner, useIsMobile } from '@agion/ui'
import { useTranslation } from 'react-i18next'
import { Sidebar } from './InfraSidebar'
import { cn } from '@/core/infra_utils'

export const MainLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false)
  const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false)
  const isMobile = useIsMobile()
  const { t } = useTranslation('pages')
  const collapsed = isMobile ? !mobileSidebarOpen : sidebarCollapsed

  return (
    <div className="relative flex h-screen bg-[var(--background)]">
      {isMobile && mobileSidebarOpen && (
        <Button
          type="button"
          variant="ghost"
          className="absolute inset-0 z-30 h-full w-full rounded-none bg-black/30 hover:bg-black/30"
          aria-label={t('sidebar.collapseSidebar')}
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}
      <aside
        className={cn(
          'bg-slate-50 dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700/50 flex-shrink-0 transition-all duration-300',
          collapsed ? 'w-16' : 'w-64',
          isMobile && mobileSidebarOpen && 'absolute inset-y-0 left-0 z-40 shadow-xl'
        )}
      >
        <Sidebar
          collapsed={collapsed}
          onToggleCollapse={() => isMobile
            ? setMobileSidebarOpen((open) => !open)
            : setSidebarCollapsed((value) => !value)}
        />
      </aside>

      <main className="min-w-0 flex-1 overflow-auto bg-[var(--background)]">
        <Suspense
          fallback={
            <div className="flex h-full items-center justify-center">
              <Spinner size="lg" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
